import { handleTrack } from '../../../../../../utils/tracker';
import useCopy from '../../../../utils/hooks/use-copy';
import { sanitizeRichText } from '../../../../utils/textUtils';

import { IPlan } from './types';
import { startFilingLink } from '../../../../../income-tax/static/data';

export const PlanCardPartner = ({
  plan,
  setShowModal,
  index = 0,
  setCurrentIndex,
  heading = '',
  icon = '',
}: {
  plan: IPlan;
  setShowModal: (value: boolean) => void;
  index: number | undefined;
  setCurrentIndex: (value: number) => void;
  heading: string | undefined;
  icon: string | undefined;
}) => {
  const delay = 1000;
  const { copied, handleCopyCoupon } = useCopy(plan.coupon?.code || '', delay);
  return (
    <div className="border rounded-3xl w-[31%] sm:w-full sm:mb-[19px] border-blue-100 flex flex-col justify-between">
      <div>
        <div
          className=" items-center gap-3 w-full justify-between px-6 py-7 rounded-tr-3xl"
          style={{
            background:
              'linear-gradient(128.65deg, rgba(238, 245, 255, 0.4) 31.8%, #EEF5FF 105.92%)',
          }}
        >
          <div className="flex items-center gap-3 justify-between">
            <div className="font-semibold text-s-20 max-w-[57%]">{heading}</div>
            <div className="w-20 h-20">
              <img src={icon} className="w-20 h-20 sm:w-16 sm:h-16" />
            </div>
          </div>
          <div className="flex items-center gap-4 justify-start sm:justify-start sm:pt-5">
            <div className="font-bold text-s-32 flex  gap-1 items-end sm:text-s-28">
              ₹{Math.floor(plan.planDetails.pricing.discountedPrice)}
              <span className="text-sm font-normal text-s-14 text-grey-500 pb-2 sm:text-s-12">
                Onwards
              </span>
            </div>
          </div>
        </div>
        {plan.coupon && (
          <>
            <div
              className=" gap-3 w-full flex justify-between px-6 py-3 items-center cursor-pointer"
              style={{
                background: '#EEF5FF',
              }}
              onClick={(e) => {
                handleCopyCoupon();
                handleTrack({
                  label: `plan-card_copy`,
                  obj: e.target,
                  value: plan?.coupon?.code,
                });
              }}
            >
              <div className=" text-s-20 font-bold sm:text-base ">
                Get {Math.floor(plan.coupon.discountValue)}% OFF
              </div>
              <div className="flex gap-1 sm:text-s-12 text-s-14 font-medium">
                Code:{' '}
                <span className="text-blue-400 sm:text-s-12 sm:align-center flex font-medium">
                  {plan.coupon.code}{' '}
                </span>
                <img
                  className="w-5 h-5 ml-1.5"
                  src={
                    copied
                      ? 'https://assets.clear.in/cleartax/images/1712001391_checkcircle1.svg'
                      : 'https://assets.clear.in/cleartax/images/1714203952_copy.svg'
                  }
                  alt="copy coupon"
                />
              </div>
            </div>
          </>
        )}
        <div className="px-6 py-8">
          <ul className="list-inside space-y-1 text-sm text-grey-700">
            {plan?.planDetails?.whenRequired?.map((feat, idx) => (
              <li key={idx} className="flex align-top">
                <img
                  src="https://assets.clear.in/cleartax/images/1746722818_checkcircle4.svg"
                  className="w-6 h-6"
                />
                <div
                  className="text-font-500 text-s-16 font-medium"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeRichText(feat.richText),
                  }}
                ></div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div>
        <a href={startFilingLink} className="mb-3 flex justify-center">
          <button
            className="button button-bluefilled rounded-md text-base py-2 w-[90%] max-w-[300px]"
            type="button"
            aria-label="File now"
            onClick={(e) => {
              setShowModal(true);
              setCurrentIndex(index);
              handleTrack({
                label: `file_now_button`,
                obj: e.currentTarget,
                value: plan?.planDetails.name,
              });
            }}
          >
            File Now
          </button>
        </a>
        <a
          className="flex justify-center py-3 text-blue-600 text-base font-bold hover:cursor-pointer"
          onClick={(e) => {
            setShowModal(true);
            setCurrentIndex(index);
            handleTrack({
              label: `plan-card`,
              obj: e.target,
              value: plan?.planDetails.name,
            });
          }}
        >
          Know More
        </a>
      </div>
    </div>
  );
};
